/**
*  料金シミュレーター
*
*  短期入所 & 短期入所（認知棟）
*
*  @since 2019.9.3
*  @use jQuery
*/



/**
*  Variables
*
*  自己負担となる利用金額
*/

//短期入所
const array_short = {
  // 所得段階 : [ 無, 第1段階, 第2段階, 第3段階 ]
  income : [ 1670, 300, 390, 650 ],

  /* 居住費 */
  // 多床室 : [ 無, 第1段階, 第2段階, 第3段階 ]
  multi  : {
    four : [ 530, 0, 370, 370 ],
    two  : [ 0, 0, 0, 0 ]
  },
  // 個室 : [ 無, 第1段階, 第2段階, 第3段階 ]
  single : [ 3740, 0, 490, 1310 ],

  /* 介護度に応じたサービス料 */
  kaigo :
  [
    { // 介護度 1 : [ 1割, 2割, 3割 ]
      multi  : {
        four : [ 1703, 3017, 4331  ],
        two  : [ 0, 0, 0, 0 ]
      },
      single : [ 1615, 284, 4067 ]
    },
    { // 介護度 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1786, 3183, 4580 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1695, 3000, 4305 ]
    },
    { // 介護度 3 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1855, 3320, 4785 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1763, 3137, 4511 ]
    },
    { // 介護度 4 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1917, 3444, 4972 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1826, 3263, 4700 ]
    },
    { // 介護度 5 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1980, 3570, 5161 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1887, 3385, 4883 ]
    },
    { // 要支援 1 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1467, 2545, 3623 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1425, 2460, 3495 ]
    },
    { // 要支援 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1640, 2891, 4142 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1580, 2771, 3962 ]
    }
  ]
}

//短期入所（認知棟）
const array_shortSub = {
  // 所得段階 : [ 無, 第1段階, 第2段階, 第3段階 ]
  income : [ 1670, 300, 390, 650 ],

  /* 居住費 */
  // 多床室 : [ 無, 第1段階, 第2段階, 第3段階 ]
  multi  : {
    four : [ 530, 0, 370, 370 ],
    two  : [ 0, 0, 0, 0 ]
  },
  // 個室 : [ 無, 第1段階, 第2段階, 第3段階 ]
  single : [ 2090, 0, 490, 1310 ],

  /* 介護度に応じたサービス料 */
  kaigo :
  [
    { // 介護度 1 : [ 1割, 2割, 3割 ]
      multi  : {
        four : [ 1786, 3183, 4580 ],
        two  : [ 0, 0, 0, 0 ]
      },
      single : [ 1698, 3007, 4315 ]
    },
    { // 介護度 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1869, 3348, 4828 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1777, 3165, 4553 ]
    },
    { // 介護度 3 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1938, 3486, 5034 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1846, 3303, 4759 ]
    },
    { // 介護度 4 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 2000, 3610, 5220 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1909, 3429, 4949 ]
    },
    { // 介護度 5 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 2063, 3736, 5409 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1970, 3551, 5132 ]
    },
    { // 要支援 1 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1550, 2710, 3871 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1508, 2626, 3744 ]
    },
    { // 要支援 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1723, 3057, 4390 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1663, 2937, 4211 ]
    }
  ]
}




/**
*  function
*  動作
*/

// 短期入所
$( calcBtn.shortStay ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.shortStay ).serializeArray();
  const selectVal = selectCheck( currentForm.shortStay, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_short.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_short.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_short.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }
    // 結果を出して表示する
    const result = ( array_short.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * parseInt( selectVal.days, 10 );
    $( resultElm.shortStay ).html( numberWithComma.format( result ) );
    $( resultElm.shortStayDays ).html( selectVal.days );
  } // end of 計算処理開始
return;
});



// 短期入所（認知棟）
$( calcBtn.shortStaySub ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.shortStaySub ).serializeArray();
  const selectVal = selectCheck( currentForm.shortStaySub, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_shortSub.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_shortSub.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_shortSub.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_shortSub.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_shortSub.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_shortSub.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }

    // 結果を出して表示する

    const result = ( array_shortSub.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * parseInt( selectVal.days, 10 );
    $( resultElm.shortStaySub ).html( numberWithComma.format( result ) );
    $( resultElm.shortStaySubDays ).html( selectVal.days );
  } // end of 計算処理開始

return;

});
